module.exports = __webpack_public_path__ + "media/bootstrap-icons/messenger-7bd266c3.svg";